'use client';
import { jsx } from 'react/jsx-runtime';
import cl from 'clsx/lite';
import { forwardRef } from 'react';

/**
 * Fieldset component, used to wrap a form field. Uses native `fieldset` element.
 *
 * @example
 * <Fieldset>
 *   <Fieldset.Legend>Skriv inn dine svar</Fieldset.Legend>
 *   <Fieldset.Description>
 *     Gi en kort beskrivelse i begge feltene
 *   </Fieldset.Description>
 *   <Field>
 *     <Label>Kort beskrivelse</Label>
 *     <Input />
 *   </Field>
 * </Fieldset>
 */
const Fieldset = forwardRef(function Fieldset({ className, ...rest }, ref) {
    return (jsx("fieldset", { className: cl('ds-fieldset', className), ref: ref, ...rest }));
});

export { Fieldset };
